import { render, staticRenderFns } from "./ViewpointsView.vue?vue&type=template&id=5f07d502&scoped=true&"
import script from "./ViewpointsView.vue?vue&type=script&lang=ts&"
export * from "./ViewpointsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07d502",
  null
  
)

export default component.exports